import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next/";

import { Button, Frame } from "@Core/components/UI";
import { FileStepType } from "@Core/constants/ENUMS";

import { StepList } from "@PNI/components/HOC";
import { usePNIStores } from "@PNI/stores";

import { ChosenStepsProps } from "./ChosenSteps.props";

export const ChosenSteps = observer(({ className }: ChosenStepsProps) => {
  const { t } = useTranslation();
  const { FileStore } = usePNIStores();

  const steps =
    FileStore.file?.steps?.filter((step) => step.selected === true && step.type === FileStepType.STEP) || [];

  return (
    <Frame title={t("FILES.CHOSEN_STEPS.TITLE")} className={className} variant="light">
      <Frame.Body padding="3">
        {steps.length === 0 ? (
          <>
            <p className="small mb-sm color-black-light">{t("FILES.CHOSEN_STEPS.EMPTY")}</p>

            <Button tertiary to={`/dossiers/${FileStore.file?.id}/advies`} disabled={FileStore.file?.isClosed}>
              {t("FILES.CHOSEN_STEPS.ADD_BUTTON")}
            </Button>
          </>
        ) : (
          <StepList steps={steps} />
        )}
      </Frame.Body>
    </Frame>
  );
});
